import { withStyles, withTheme } from 'material-ui';
import React, { Component } from 'react';
import withRouter from 'react-router-dom/withRouter';
import Message from './components/Message';
import Document from './resource_views/Document';
import AppBarSpacing from './utils/AppBarSpacing';
import Term from './resource_views/Term';
import Index from './resource_views/Index';
import Collection from './resource_views/Collection';

class SingleResource extends Component {
  render() {
    var rendered = <Message>Resource not found!</Message>;

    var resourceID = this.props.resourceID;
    var resourceInfo = this.props.resources[this.props.match.params.resourceID];

    if(resourceInfo) {
      if(resourceInfo.type === 'document') {
        rendered = <Document resourceID={resourceID} resources={this.props.resources} />
      }else if(resourceInfo.type === 'term') {
        rendered = <Term resourceID={resourceID} resources={this.props.resources} />
      }else if(resourceInfo.type === 'index') {
        rendered = <Index resourceID={resourceID} resources={this.props.resources} />
      }else if(resourceInfo.type === 'collection') {
        rendered = <Collection resourceID={resourceID} resources={this.props.resources} />
      }
    }

    return rendered;
  }
}

export default withRouter(withTheme()(withStyles(AppBarSpacing)(SingleResource)));


// WEBPACK FOOTER //
// ./src/SingleResource.js